import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { userService, User } from '../services/user.service';
import { useAuthStore } from '@/store/authStore';

/**
 * Users allocated to the company open in this session (home company or membership).
 */
export const useUsers = (filters?: {
  company_id?: string;
  is_active?: boolean;
  search?: string;
  role_codes?: string[];
  include_user_id?: string;
}, options?: { enabled?: boolean }): UseQueryResult<User[], Error> => {
  const companyId = useAuthStore((s) => s.user?.company_id);
  return useQuery({
    queryKey: ['users', companyId, filters],
    queryFn: () => userService.getAll(filters),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!companyId && options?.enabled !== false,
  });
};

/**
 * Hook to fetch a single user by ID
 */
export const useUser = (id: string, enabled: boolean = true): UseQueryResult<User, Error> => {
  return useQuery({
    queryKey: ['user', id],
    queryFn: () => userService.getById(id),
    enabled: enabled && !!id,
  });
};
